/** 定数 */
export const ROUTE_NAME = {
  LOGIN: "Login",
  PASSWORD_RESET: "PasswordReset",
  EMPLOYEES_LIST: "EmployeesList",
  SYNC_HISTORIES_LIST: "SyncHistoriesList",
  OPERATION_LOGS_CSV: "OperationLogsCSV",
};

export const SYNC_HISTORIES_STATUS_IS_PROGRESS = 0;
export const SYNC_HISTORIES_STATUS_COMPLETED = 1;
export const SYNC_HISTORIES_STATUS_ERROR = 9;

export const SYNC_HISTORIES_STATUS_LIST = {
  [SYNC_HISTORIES_STATUS_IS_PROGRESS]: "同期中",
  [SYNC_HISTORIES_STATUS_COMPLETED]: "同期完了",
  [SYNC_HISTORIES_STATUS_ERROR]: "失敗",
};

export const TT_GENDER_MEN = 0;
export const TT_GENDER_WOMEN = 1;

export const LOADING_MODAL_ID = "loadingModalId";
